import {getConfig} from 'config';
import {getData, postData} from '../dataProvider';

export const preLaunchChecksDocGen = (data) => {
  return postData(`${getConfig('preLaunchCheckDocGen')}`, data, { responseType: 'json' });
};
